/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Input, Directive, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';

import { Point } from 'pixi.js-legacy';

import { Observable, combineLatest, Subject } from 'rxjs';
import { tap, map, takeUntil, startWith } from 'rxjs/operators';

import { PlanState } from 'src/app/services/plan-state.service';
import { logger } from '@touchplan/logging';

@Directive({
	selector: '[planPositioning]',
})
export class PlanPositioningDirective implements OnInit, OnDestroy {
	private shutdownSubject = new Subject<void>();

	//world coordinates
	@Input('planPositioning') public positionObservable: Observable<{ x: number; y: number }>; //Pointlike

	constructor(private planState: PlanState, private el: ElementRef, private renderer: Renderer2) {
		// planState.canvasConnector.cameraChange$.subscribe(c => {
		// 	logger.log('camera', c);
		// });
	}

	public ngOnInit() {
		combineLatest([
			this.positionObservable,
			this.planState.canvasConnector.cameraChange$.pipe(startWith(this.planState.canvasConnector.camera)),
		])
			.pipe(
				map(([pos, camera]) => {
					// logger.log('plan position changed', arr);
					return {
						x: camera.realToScreenX(pos.x),
						y: camera.realToScreenY(pos.y),
					};
				}),
				takeUntil(this.shutdownSubject)
			)
			.subscribe((position) => {
				// logger.log('screen position', position);
				this.renderer.setStyle(this.el.nativeElement, 'left', position.x + 'px');
				this.renderer.setStyle(this.el.nativeElement, 'top', position.y + 'px');
			});
	}

	public ngOnDestroy() {
		this.shutdownSubject.next();
	}
}
